import React from 'react';
import styled from 'styled-components/macro';
import { Row, Col } from 'antd';

import Card from 'components/Card/Card';
import EnquiryForm from './components/EnquiryForm/EnquiryForm';
import EnquiryInfo from './components/EnquiryInfo/EnquiryInfo';

import BackgroundSVG from './images/bg.svg';

const StyledEnquiryCardContents = styled(Card)`
  flex-direction: column;
  @media (min-width: 992px) {
    flex-direction: row;
  }
`;

const StyledEnquiryRow = styled(Row)`
  background-image: url(${BackgroundSVG});
  min-height: 100vh;
  background-size: cover;
`;

const Enquiry = props => {
  const { location } = props;
  const previousPath = location.state ? location.state.prevPath : '/';
  return (
  <StyledEnquiryRow type="flex" justify="center" align="middle">
    <Col span={24} lg={22}>
      <StyledEnquiryCardContents>
        <EnquiryInfo prevPath={previousPath}/>
        <EnquiryForm />
      </StyledEnquiryCardContents>
    </Col>
  </StyledEnquiryRow>
);}

export default Enquiry;
